import LeadCard from "./LeadCard";
import { useMemo } from "react";

const LeadList = ({
  list,
  tasks = [],
  onCall,
  onOpen,
  onViewActivity,
  isAdmin,
}) => {
  const taskMap = useMemo(() => {
    const map = {};

    tasks.forEach((task) => {
      if (!task.lead_id) return;

      if (!map[task.lead_id]) {
        map[task.lead_id] = [];
      }

      map[task.lead_id].push(task);
    });

    return map;
  }, [tasks]);

  return (
    <div>
      {list.map((lead) => {
        const leadTasks = taskMap[lead.id] || [];

        const overdueCount = leadTasks.filter(
          (task) => task.bucket === "overdue"
        ).length;

        const activeTaskCount = leadTasks.filter(
          (task) =>
            task.bucket !== "overdue" &&
            task.status !== "completed" &&
            task.status !== "cancelled"
        ).length;

        return (
          <div key={lead.id}>
            <LeadCard
              lead={lead}
              onCall={onCall}
              onClick={onOpen}
              overdueCount={overdueCount}
              activeTaskCount={activeTaskCount}
              onViewActivity={onViewActivity}
              isAdmin={isAdmin}
            />
          </div>
        );
      })}
    </div>
  );
};

export default LeadList;